import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { useEffect, useState } from "react";
import {
  NFCeModalDestinatarioSchema,
  NFCeModalFinalizarProps,
  NFCeModalPagamentoSchema,
} from "./NFCe.Modal.Finalizar.Dto";
import { FormatarVirgulaPonto, SoNumeros } from "src/hook/Functions";
import {
  DestinatarioNFCeDto,
  MeioPagamentoDto,
  MeioPagamentoNFCeDto,
} from "../NFCe.Dto";

const NFCeModalFinalizaCode = (props: NFCeModalFinalizarProps) => {
  const totalPago = () => {
    const pago = props.dataMeioPagamento.reduce((acc, item) => {
      const valor =
        typeof item.valorPagamento === "string"
          ? Number(FormatarVirgulaPonto(item.valorPagamento))
          : Number(item.valorPagamento);
      return acc + (isNaN(valor) ? 0 : valor);
    }, 0);
    return pago;
  };

  const totalTroco = () => {
    const troco = totalPago() - props.totalNFCe;
    if (troco < 0) {
      return 0;
    }
    return troco;
  };

  const podeFinalizar = () => {
    return totalPago() >= props.totalNFCe;
  };

  const form = useForm<MeioPagamentoNFCeDto>({
    resolver: yupResolver(NFCeModalPagamentoSchema),
  });

  const destinatarioForm = useForm<DestinatarioNFCeDto>({
    resolver: yupResolver(NFCeModalDestinatarioSchema),
  });

  const [exibirValor, setExibirValor] = useState(false);
  const [selecionadoMeioPagamento, setSelecionadoMeioPagamento] =
    useState<MeioPagamentoDto>();

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      form.setFocus("valorPagamento");
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [exibirValor]);

  const onSubmitMeioPagamento = async (data: MeioPagamentoNFCeDto) => {
    data.meioPagamento = selecionadoMeioPagamento?.meioPagamento;
    data.valorPagamento = Number(FormatarVirgulaPonto(data.valorPagamento as unknown as string));
    props.onSelect(data);
    setExibirValor(false);
    setSelecionadoMeioPagamento(undefined);
    form.reset();
  };

  const onSubmitDestinatario = async (
    data: DestinatarioNFCeDto | undefined
  ) => {
    props.onHide();
    if (data && data.documento) {
      data.documento = SoNumeros(data.documento);
      data.indicadorInscricaoEstadual = 9;
    } else {
      data = undefined;
    }
    props.onSubmit(data);
  };

  const handleClickMeioPagamento = (value: MeioPagamentoDto) => () => {
    setSelecionadoMeioPagamento(value);
    setExibirValor(true);
  };

  const onHideClick = () => {
    if (exibirValor) {
      form.reset();
      setExibirValor(false);
    } else {
      props.onHide();
    }
  };

  const onCancelClick = () => {
    setExibirValor(false);
    props.onCancel();
  };

  return {
    form,
    onSubmitMeioPagamento,
    exibirValor,
    setExibirValor,
    selecionadoMeioPagamento,
    setSelecionadoMeioPagamento,
    handleClickMeioPagamento,
    totalPago,
    totalTroco,
    onHideClick,
    podeFinalizar,
    onCancelClick,
    onSubmitDestinatario,
    destinatarioForm,
  };
};

export default NFCeModalFinalizaCode;
